define('SuiteCommerce.OrderStatus.Instrumentation.Model', [
	'SuiteCommerce.OrderStatus.Instrumentation.Logger',
	'Backbone',
	'underscore',
], function define(Logger, Backbone, _) {
	'use strict';
	var DEFAULT_SEVERITY = 'info';
	return Backbone.Model.extend({
		defaults: function defaults() {
			return {
				parametersToSubmit: {},
				timer: {},
				severity: DEFAULT_SEVERITY,
			};
		},
		startTimer: function startTimer() {
			var startTime = this.getTimestamp();
			var timer = this.get('timer');
			timer.startTime = startTime;
			this.set('timer', timer);
		},
		endTimer: function endTimer() {
			var endTime = this.getTimestamp();
			var timer = this.get('timer');
			timer.endTime = endTime;
			this.set('timer', timer);
		},
		getTimestamp: function getTimestamp() {
			if (!this.isOldInternetExplorer()) {
				return performance.now() || Date.now();
			}
			return Date.now();
		},
		getElapsedTimeForTimer: function getElapsedTimeForTimer() {
			var timer = this.get('timer');
			if (timer.startTime && timer.endTime) {
				if (timer.startTime > timer.endTime) {
					console.warn('Start time should be minor that end time in timer');
					return null;
				}
				return timer.endTime - timer.startTime;
			}
			if (!timer.startTime) console.warn('The Start time is not defined');
			if (!timer.endTime) console.warn('The End time is not defined');
			return null;
		},
		setParametersToSubmit: function setParametersToSubmit(data) {
			var self = this;
			_.each(data, function setLogParameter(value, parameter) {
				self.setParameterToSubmit(parameter, data[parameter]);
			});
		},
		setParameterToSubmit: function setParameterToSubmit(parameter, value) {
			var logData = this.get('parametersToSubmit');
			logData[parameter] = value;
			this.set('parametersToSubmit', logData);
		},
		setSeverity: function setSeverity(severity) {
			this.set('severity', severity);
		},
		submit: function submit() {
			if (!this.isOldInternetExplorer()) {
				switch (this.get('severity')) {
					case 'error':
						this.submitAsError();
						break;
					default:
						this.submitAsInfo();
				}
			}
		},
		isOldInternetExplorer: function isOldInternetExplorer() {
			return !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
		},
		submitAsError: function submitAsError() {
			Logger.getLogger().error(this.get('parametersToSubmit'));
		},
		submitAsInfo: function submitAsInfo() {
			Logger.getLogger().info(this.get('parametersToSubmit'));
		},
	});
});
